import { DASHBOARD_WIDGETS } from "frontend-dashboard-contracts";

export const DEFAULT_ACTIVE_WIDGETS: string[] = [...DASHBOARD_WIDGETS];

export const STORAGE_KEYS = {
    LAYOUTS: "dashboard-layouts",
    WIDGETS: "dashboard-widgets",
} as const;
